<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 450px" class="yl-flex flex_between">
                    <Input placeholder="搜索员工姓名" v-model="name" style="width: 300px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
                </div>

            </div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
					<DatePicker v-show="timePeriod == '7' " type="month" placeholder="请选择月份" v-model="timePeriodDate" style="width: 200px;margin: 0 20px;"></DatePicker>
                </RadioGroup>
            </div>


            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">

                </Table>
            </div>


        </div>
    </Card>
</template>
<script>
    import {mapGetters} from "vuex";
	import {getSalaryList} from "../../api/finance";

	export default {
        name: "History",
        components: {},

        data() {
            return {
                name: '',
                timePeriod: '6',
                timePeriodDate: '',
                datas: [ ],
                columns: [

                    {
                        "title": "所属部门",
                        "key": "department_name",
                        align: 'center'
                    },
                    {
                        "title": "员工姓名",
                        "key": "name",
                        align: 'center'
                    },
                    {
                        "title": "月份",
                        "key": "month",
                        align: 'center'
                    },
                    {
                        "title": "基本工资",
                        "key": "base",
                        align: 'center'
                    },
                    {
                        "title": "业绩提成",
                        "key": "achievement",
                        align: 'center'
                    },
                    {
                        "title": "考核奖励",
                        "key": "assessment",
                        align: 'center'
                    },
                    {
                        "title": "考勤",
                        "key": "attendance",
                        align: 'center'
                    },
                    {
                        "title": "应发工资",
                        "key": "gross_pay",
                        align: 'center'
                    },
					{
						"title": "个税",
						"key": "tax",
						align: 'center'
					},
                    {
                        "title": "社保代缴",
                        "key": "security",
                        align: 'center'
                    },
                    {
                        "title": "公积金代缴",
                        "key": "accumulation_fund",
                        align: 'center'
                    },
                    {
                        "title": "其他扣款",
                        "key": "other_fund",
                        align: 'center'
                    },
                    {
                        "title": "实发工资金额",
                        "key": "net_pay",
                        align: 'center',
                        width: '120'
                    }
                ]
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
        methods: {

            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate,
					name: that.name
				};
				let res = await getSalaryList(that, data);
				if (res.code == 1) {
					that.datas = res.data.list;
				}
			},
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
